import {
  route,
} from '@app/Routing/helpers'

import { accessPermission, REDIRECT_MAP } from '@access/permissions'

import {
  createRoutes as createQuickStartRoutes,
} from '@app/Seller/QuickStart/routes'

import {
  ALL,
  BLOCKED_TOKEN, SUSPENDED_TOKEN,
} from '@app/Seller/accessTokens'

import {
  createRoutes as createProductsRoutes,
} from '@app/Seller/Products/routes'
import {
  createRoutes as createChatsRoutes,
} from '@app/Seller/Chats/routes'

import {
  createRoutes as createOrdersRoutes,
} from '@app/Seller/Orders/routes'

import {
  createRoutes as createSettingsRoutes,
} from '@app/Seller/Settings/routes'

import {
  createRoutes as createBalanceRoutes,
} from '@app/Seller/Balance/routes'

import {
  createRoutes as createModulesRoutes,
} from '@app/Seller/Modules/routes'

import {
  createRoutes as createSetsRoutes,
} from '@app/Seller/Sets/routes'

import {
  createRoutes as createReviewRoutes,
} from '@app/Seller/Review/routes'

import {
  createRoutes as createShippingRoutes,
} from '@app/Seller/Shipping/routes'

import {
  createRoutes as createPaymentsRoutes,
} from '@app/Seller/Payments/routes'

import {
  createRoutes as createImporterRoutes,
} from '@app/Seller/Importer/routes'

import {
  createRoutes as createIntegrationsRoutes,
} from '@app/Seller/Integrations/routes'

const UserInfo = () => import('@app/Seller/User/Info')
const CartView = () => import('@app/Seller/Cart/View')

const DashboardView = () => import('@app/Seller/Dashboard/View')

const Page403 = () => import('@app/Seller/403')
const Page404 = () => import('@app/Seller/404')

const Documents = () => import('@app/Seller/Documents/View')
const Tools = () => import('@app/Seller/Tools/View')
const Blocked = () => import('@app/Seller/Views/Blocked')
const Suspended = () => import('@app/Seller/Views/Suspended')

const USER_DATA = 'personal/'
const CART_LIST = 'cart/'
const DASHBOARD_VIEW = 'dashboard/'

const DOCUMENTS_VIEW = 'documents/'
const TOOLS_VIEW = 'tools/'
const BLOCKED_VIEW = 'blocked/'
const SUSPENDED_VIEW = 'suspended/'

const PAGE_403_VIEW = '/403/'
const PAGE_404_VIEW = '/404/'

export const SELLER_PREFIX = 'seller:'
const p = name => SELLER_PREFIX + name

export const SELLER_USER_PERSONAL_NAME = p('personal')
export const SELLER_ORDERS_LIST_NAME = p('orders')
export const SELLER_CART_LIST_NAME = p('cart')
export const SELLER_DASHBOARD_VIEW_NAME = p('dashboard')

export const SELLER_DOCUMENTS_VIEW_NAME = p('documents')
export const SELLER_PAYMENTS_VIEW_NAME = p('payments')
export const SELLER_TOOLS_VIEW_NAME = p('tools')
export const SELLER_BLOCKED_VIEW_NAME = p('blocked')
export const SELLER_SUSPENDED_VIEW_NAME = p('suspended')

export const ERROR_404 = p('404')
export const ERROR_403 = p('403')

export function createRoutes(options) {
  return [
    route(DASHBOARD_VIEW, DashboardView, SELLER_DASHBOARD_VIEW_NAME, {
      meta: accessPermission(ALL),
    }),
    ...createQuickStartRoutes(options),
    ...createProductsRoutes(options),
    ...createImporterRoutes(options),
    ...createOrdersRoutes(options),
    ...createSettingsRoutes(options),
    ...createBalanceRoutes(options),
    ...createChatsRoutes(options),
    ...createModulesRoutes(options),
    ...createSetsRoutes(options),
    ...createReviewRoutes(options),
    ...createShippingRoutes(options),
    ...createPaymentsRoutes(options),
    ...createIntegrationsRoutes(options),
    route(USER_DATA, UserInfo, SELLER_USER_PERSONAL_NAME, options),
    route(CART_LIST, CartView, SELLER_CART_LIST_NAME, {
      meta: accessPermission(ALL),
    }),
    route(DOCUMENTS_VIEW, Documents, SELLER_DOCUMENTS_VIEW_NAME, {
      meta: accessPermission(ALL),
    }),
    route(TOOLS_VIEW, Tools, SELLER_TOOLS_VIEW_NAME, {
      meta: accessPermission(ALL),
    }),
    route(BLOCKED_VIEW, Blocked, SELLER_BLOCKED_VIEW_NAME, {
      meta: accessPermission(BLOCKED_TOKEN),
    }),
    route(SUSPENDED_VIEW, Suspended, SELLER_SUSPENDED_VIEW_NAME, {
      meta: accessPermission(SUSPENDED_TOKEN),
    }),
    { path: '', redirect: { name: REDIRECT_MAP[window.shop_status] } },
    { path: PAGE_403_VIEW, name: ERROR_403, component: Page403 },
    { path: PAGE_404_VIEW, name: ERROR_404, component: Page404 },
  ]
}
